<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="aulasEmConflitos">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                          autocomplete="off"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="12" v-if="gestaoParaDatePicker">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label>Selecione uma data</e-label>
                      <e-date-picker-calendario-letivo
                        ref="datePickerCalendarioLetivo"
                        v-model="dataAulaDuplicada"
                        :gestao-de-aula="gestaoParaDatePicker"
                        :inicio-periodo-etapa="etapa?.periodo_inicial"
                        :fim-periodo-etapa="etapa?.periodo_final"
                        :error-messages="errors"
                        label="Escolha uma data"
                        @date-changed="onDateChanged"
                        @horarios-changed="onHorariosChanged"
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="gestaoDeAula.tipo_de_aula !== 'Aula Remota' && gestaoParaDatePicker"
                    cols="12"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <v-select
                        :items="horariosDisponiveis"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        solo
                        autocomplete="off"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12" v-if="aulasEmConflitos">
                    <v-alert type="warning" dense text border="left" class="mt-2">
                      <div class="d-flex align-center justify-space-between">
                        <span>
                          <strong>Conflito detectado!</strong> Esta turma já possui uma aula
                          cadastrada neste horário.
                        </span>
                        <v-btn
                          text
                          small
                          color="warning"
                          @click="mostrarBottomSheetConflitos = true"
                        >
                          Ver detalhes
                        </v-btn>
                      </div>
                    </v-alert>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12" v-else>
                    <v-alert color="warning" dense outlined type="warning">
                      Escolha uma turma antes de selecionar data e horário.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Campos de experiências</e-label>
                    <ul>
                      <li
                        v-for="campo_de_experiencia in gestaoDeAula.campos_de_experiencias.filter(
                          (c) => c
                        )"
                        :key="campo_de_experiencia"
                        class="font-weight-regular"
                      >
                        {{ campo_de_experiencia }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Eixos temáticos</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.eixos)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Estratégias de ensino</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.estrategias)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Recursos</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.recursos)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Atividade de classe</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.atividade_classe)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Atividade de casa</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.atividade_casa)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Observações</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(gestaoDeAula.observacoes)"
                    ></div>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido || aulasEmConflitos"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>

    <v-bottom-sheet v-model="mostrarBottomSheetConflitos" scrollable>
      <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
        <v-btn color="error" dark small @click="mostrarBottomSheetConflitos = false">
          Fechar
        </v-btn>

        <h2 class="mt-4">Aulas conflitadas</h2>
        <p class="mt-2 text-body-1">
          Já existe uma aula cadastrada para esta turma neste horário. Selecione uma data ou horário
          diferente para continuar.
        </p>

        <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
          <template>
            <thead style="background-color: #e0e0e0">
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Professor</th>
                <th class="text-left">Situação</th>
                <th class="text-left">Data/Horário</th>
                <th class="text-left">Turma</th>
                <th class="text-left">Campos de Experiências</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="item in aulasConflitadas" :key="item.id">
                <td>{{ item.id }}</td>
                <td>
                  {{ item.professor.nome }}
                  <br />
                  <v-chip color="grey" dark x-small>
                    {{ item.turma?.franquia?.descricao }}
                  </v-chip>
                </td>
                <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                <td>
                  <span>{{ item.data.split("-").reverse().join("/") }}</span>
                  - {{ item.horario?.descricao || "Sem horário" }}
                </td>
                <td>{{ item.turma?.descricao }}</td>
                <td>
                  <div v-if="item.campos_de_experiencias">
                    <template v-if="typeof item.campos_de_experiencias === 'string'">
                      <v-chip
                        v-for="(campo, idx) in JSON.parse(item.campos_de_experiencias).filter(
                          (c) => c
                        )"
                        :key="idx"
                        class="ma-1"
                        color="primary"
                        dark
                        x-small
                      >
                        {{ campo }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip
                        v-for="(campo, idx) in item.campos_de_experiencias.filter((c) => c)"
                        :key="idx"
                        class="ma-1"
                        color="primary"
                        dark
                        x-small
                      >
                        {{ campo }}
                      </v-chip>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-bottom-sheet>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    etapa: {
      type: Object,
    },
  },
  data() {
    return {
      dataAulaDuplicada: null,
      gestaoDeAula: {},
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      horarioSelecionado: null,
      horariosDisponiveis: [],
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarBottomSheetConflitos: false,
    };
  },
  computed: {
    aulaRemota() {
      return this.gestaoDeAula?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
    gestaoParaDatePicker() {
      // Retorna a estrutura de gestão esperada pelo componente
      // usando os dados de turmaSelecionada
      if (!this.turmaSelecionada?.relacoesDiasHorarios) {
        return null;
      }

      return {
        turma: this.turmaSelecionada.turma,
        relacoesDiasHorarios: this.turmaSelecionada.relacoesDiasHorarios,
        disciplina: this.gestaoDeAula?.disciplina,
      };
    },
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        // Limpar data e horário quando turma mudar
        if (val?.turma?.id) {
          this.dataAulaDuplicada = null;
          this.horarioSelecionado = null;
          this.horariosDisponiveis = [];
        }
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            this.turmas =
              await this.$services.gestoesDeAulasService.listarGestoesProfessorParaExportar(
                this.gestaoDeAula
              );
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      if (value && this.horarioSelecionado?.id && this.turmaSelecionada?.turma?.id) {
        this.verificarConflitos();
      }
    },
    horarioSelecionado: {
      handler(val) {
        if (val?.id && this.dataAulaDuplicada && this.turmaSelecionada?.turma?.id) {
          this.verificarConflitos();
        }
      },
    },
  },
  methods: {
    onDateChanged() {
      // A data já está atualizada no v-model (dataAulaDuplicada)
      // Limpar horário selecionado quando data mudar
      this.horarioSelecionado = null;
    },

    onHorariosChanged(horarios) {
      // Atualizar horários disponíveis baseado na data selecionada
      this.horariosDisponiveis = horarios;

      // Limpar horário selecionado se não estiver na nova lista
      if (this.horarioSelecionado) {
        const horarioExists = horarios.some((h) => h.id === this.horarioSelecionado.id);
        if (!horarioExists) {
          this.horarioSelecionado = null;
        }
      }
    },

    async verificarConflitos() {
      const isInfantil =
        this.turmaSelecionada?.turma?.isInfantil ||
        this.turmaSelecionada?.turma?.curso_id === 1 ||
        this.turmaSelecionada?.turma?.series?.[0]?.curso_id === 1;

      if (!isInfantil) {
        this.aulasConflitadas = [];
        this.aulasEmConflitos = false;
        return;
      }

      try {
        const partesData = this.dataAulaDuplicada.split("/");
        const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

        const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
          dataFormatada,
          this.horarioSelecionado.id,
          this.turmaSelecionada.turma.id,
          0
        );

        if (response.data.length > 0) {
          this.aulasConflitadas = response.data;
          this.aulasEmConflitos = true;
        } else {
          this.aulasConflitadas = [];
          this.aulasEmConflitos = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    enableSubmit() {
      if (
        !this.turmaSelecionada?.turma?.id ||
        !this.dataAulaDuplicada ||
        !this.horarioSelecionado?.id
      ) {
        this.$toast.danger("Preencha todos os campos obrigatórios: turma, data e horário.");
        return;
      }
      if (this.aulasEmConflitos) {
        this.$toast.danger(
          "Existe um conflito de horário. Selecione uma data ou horário diferente."
        );
        return;
      }

      this.confirmDialog = !this.confirmDialog;
    },
    async exportarAula() {
      if (this.aulasEmConflitos) {
        this.$toast.danger("Existe um conflito de horário. Não é possível exportar a aula.");
        return;
      }

      if (
        !this.dataAulaDuplicada ||
        !this.horarioSelecionado?.id ||
        !this.turmaSelecionada?.turma?.id
      ) {
        this.$toast.danger("Preencha todos os campos obrigatórios antes de exportar.");
        return;
      }

      this.$loaderService.open("Exportando a Aula");
      try {
        // Converter data de DD/MM/YYYY para YYYY-MM-DD
        const partesData = this.dataAulaDuplicada.split("/");
        const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

        this.gestaoDeAula.data = dataFormatada;
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.gestaoDeAula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$emit("dialogChange", false);
        this.limparCampos();
        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.aulasConflitadas = error.response.data.aulas_conflitadas || [];
          this.aulasEmConflitos = true;
          this.$toast.danger(
            error.response.data.message ||
              "Já existe uma aula cadastrada para esta turma neste horário"
          );
        } else {
          this.$handleError(error);
        }
      } finally {
        this.$loaderService.close();
      }
    },
    formatarQuebrasDeLinha(texto) {
      return texto ? texto.replace(/\n/g, "<br>") : "";
    },
    limparCampos() {
      this.horariosDisponiveis = [];
      this.turmaSelecionada = null;
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;

      this.aulasEmConflitos = false;
      this.aulasConflitadas = [];

      if (this.$refs.datePickerCalendarioLetivo) {
        this.$refs.datePickerCalendarioLetivo.limpar();
      }

      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
